import { Reducer } from 'redux';
import * as Actions from './actions';
import { IConversationState, INotesState, IConversationMessage } from './interfaces/state';
import { PO_DETAILS_ACTIONS } from '@/app/areas/unacknowledged-po/details/actions';
import { CHANGE_REQUESTS_LIST_ACTIONS } from '@/app/areas/unacknowledged-po/details/components/change-requests/change-requests-actions';
import { ConversationSectionEnum } from '@/app-constants';

const initialState: IConversationState = {
  entityId: 0,
  entityType: 0,
  error: null,
  loading: false,
  messages: [],
  conversationId: 0,
  purchaseOrderId: 0,
  showConversation: false,
  readOnly: false,
  sectionId: ConversationSectionEnum.Conversation,
};

export const conversationReducer: Reducer<IConversationState> = (state: IConversationState = initialState, action) => {
  switch (action.type) {

    case Actions.CONVERSATION_ACTIONS.REQUEST:
      return {
        ...state,
        entityId: action.payload.entityId,
        entityType: action.payload.entityType,
        showConversation: true,
        conversationId: action.payload.conversationId,
        readOnly: action.payload.readOnly,
        loading: true,
        sectionId: action.payload.sectionId
      };

    case Actions.CONVERSATION_ACTIONS.POST:
      return {
        ...state,
        conversationId: action.request.conversationId,
        loading: true
      };

    case Actions.CONVERSATION_ACTIONS.SUCCESS:
      return {
        ...state,
        entityId: action.payload.entity.entityId,
        entityType: action.payload.entity.entityType,
        loading: false,
        messages: action.payload.messages
      };

    case Actions.CONVERSATION_ACTIONS.FAILURE:
      return {
        ...state,
        loading: false,
        error: action.error
      };

    case Actions.CONVERSATION_ACTIONS.HIDE:
      return {
        ...state,
        showConversation: false
      };

    case PO_DETAILS_ACTIONS.SUCCESS:
      const conversationId = action.payload.conversationId || 0;
      return {
        ...state,
        conversationId,
        purchaseOrderId: action.payload.purchaseOrderId,
        loading: false
      };

    case CHANGE_REQUESTS_LIST_ACTIONS.SUCCESS:
    case PO_DETAILS_ACTIONS.CLEAR:
      return { ...initialState };

    default:
      return state;
  }
};

const initialNotesState: INotesState = {
  loading: false,
  error: null,
  notes: []
}

export const notesReducer: Reducer<INotesState> = (state: INotesState = initialNotesState, action) => {
  switch (action.type) {
    case Actions.CONVERSATION_ACTIONS.NOTES_REQUEST:
      return {
        ...state,
        loading: true
      };

    case Actions.CONVERSATION_ACTIONS.NOTES_REQUEST_SUCCESS:
      return {
        ...state,
        error: null,
        notes: action.payload.notes,
        loading: false
      };

    case Actions.CONVERSATION_ACTIONS.NOTES_FAILURE:
      return {
        ...state,
        error: action.error,
        loading: false
      };

    case Actions.CONVERSATION_ACTIONS.NOTES_POST:
      return {
        ...state,
        notes: [...state.notes, {
          content: action.payload.note,
          createdByDisplayName: action.payload.createdByDisplayName,
          createdDate: new Date().toString()
        } as IConversationMessage]
      };

    case Actions.CONVERSATION_ACTIONS.NOTES_POST_SUCCESS:
      return {
        ...state,
        error: null
      };

    default:
      return state;
  }
};
